module.exports = __webpack_public_path__ + "static/img/tbg3.71be4c68.png";